import {bezierEdge, DPart, Node, nodeData, paperInfo, scale} from "../store/model";
import * as d3 from "d3";
import store from "../store"
import paper2edge from "../data/paper2edge.json"
import edgesTotal from '../data/edgesTotal.json';


export function generateNodesData(Division: DPart[], nodesDataList: nodeData[], top: number, bottom: number, tension: number, scale: number) {
    const nodesData: Node[] = []
    for (let di = 0; di < Division.length; di++) {
        const tD = Division[di];
        const blankWidth = tD.maxR * scale * 2;
        let height = bottom - top;
        let max = 0;
        const r = [];
        const rR = [];
        for (let i = tD.bIndex; i <= tD.eIndex; i++) {
            const sqrtR = Math.sqrt(nodesDataList[i].size);
            if (max < sqrtR) max = sqrtR;
            r.push(sqrtR)
        }
        for (let i = tD.bIndex; i <= tD.eIndex; i++) {
            const tr = tD.maxR * scale * r[i - tD.bIndex] / max;
            rR.push(tr)
            height -= 2 * tr;
        }

        height -= tD.blankD.length * blankWidth
        const k = height / (tD.eIndex - tD.bIndex + 1);
        let last = top - k / 2;
        let lastR = 0;
        let count = 0;
        for (let i = tD.bIndex; i <= tD.eIndex; i++) {
            const temp = nodesDataList[i];
            const rn = rR[i - tD.bIndex];
            last = last + lastR + rn + k;
            const t = {
                "id": temp.id,
                "cx": tD.cx * scale * 3840 / 2105,
                "cy": last,
                "r": rn,
                "name": temp.name,
                "size": temp.size,
                "type": temp.type,
                "center": last,
            };
            lastR = rn;
            count++;
            nodesData.push(t)

            if (tD.blankD.includes(i + 1)) {
                let center = t.cy
                const ct = (nodesData[i].cy + nodesData[i - count + 1].cy) / 2
                for (let j = i; j > i - count; j--) {
                    nodesData[j].center = (1 - tension) * (nodesData[j].cy + center) / 2 + ct * (tension);
                }
                count = 0;
                lastR += blankWidth;
            }
        }
    }
    return nodesData;
}


export function getBezierEdgesParseByEdgeList(nodes: Node[], Pcp: number[], is2B: boolean, WH: scale, tension: number) {
    const bezierEdges: bezierEdge[] = []
    for (let i = 0; i < Pcp.length; i++)
        bezierEdges.push(generateEdgeParseByID(Pcp[i], nodes, is2B, WH, tension))
    return bezierEdges
}

export function generateEdgeParseByID(id: number, nodes: Node[], type: boolean, WH: scale, tension: number) {
    const p2 = id % 100;
    const p1 = (id - p2) / 100;
    const x1 = nodes[p1 - 1].cx, y1 = nodes[p1 - 1].cy, x3 = nodes[p2 - 1].cx,
        y3 = nodes[p2 - 1].cy;
    const center1 = nodes[p1 - 1].center, center2 = nodes[p2 - 1].center
    const x2 = (x1 + x3) / 2, y2 = (center1 + center2) / 2;
    const dx = -200 * 3840 / 2106 * WH.height / 2016, dy = 0;
    const path = d3.path();

    if (type) {
        path.moveTo(x1, y1)
        path.bezierCurveTo(x1 - 2 * dx * tension, y1 + 2 * dy, x3 + 2 * dx * tension, y3 + 2 * dy, x3, y3);
    } else {
        const dx = -180 * 3840 / 2106 * WH.height / 2016
        path.moveTo(x1, y1)
        path.bezierCurveTo(x1 - dx, y1 + dy, x2 + dx, y2 - dy, x2, y2);
        path.bezierCurveTo(x2 - dx, y2 + dy, x3 + dx, y3 - dy, x3, y3);
    }
    return {ID: id, pathParse: path.toString(), eInfo: {p1, p2}};
}

export function getRelatedPapersAndEdgesByNodes(Ps: number[]) {
    const edgesData = store.getState().PaperEdges
    let edgesD = []
    let edges: number[]
    let papers: number[] = []
    let idP = []
    if (Ps.length > 0) {
        for (let i = 0; i < Ps.length; i++)
            idP.push(Ps[i])
        for (let i = 0; i < edgesData.length; i++) {
            const Ns = [];
            Ns.push(edgesData[i].p1)
            Ns.push(edgesData[i].p2)
            Ns.push(edgesData[i].p3)
            Ns.push(edgesData[i].p4)
            const temp = new Set([...Ns, ...idP])
            if (Ns.length === temp.size) {
                for (let j = 1; j < store.getState().Division.length; j++) {
                    edgesD.push(Ns[j - 1] * 100 + Ns[j]);
                }
                papers.push(edgesData[i].pid)
            }
        }
    } else {
        edgesD = edgesTotal
        const Papers: paperInfo[] = store.getState().Papers.Papers
        for (let i = 0; i < Papers.length; i++) {
            if (Papers[i].nodeList.length > 0 && Papers[i].id !== 130)
                papers.push(Papers[i].id)
        }
    }

    edges = Array.from(new Set(edgesD))
    papers = Array.from(new Set(papers))
    return filterEdgeByPaper(edges, papers, Ps.length > 0)
}

export function updateSelectNodesState(id: number) {
    const Nodes: Node[] = store.getState().NodesData.Nodes;
    const ClickedNodes: number[] = store.getState().NodesData.SelectedNodes;
    let tempN = Nodes[id - 1];
    let type = tempN.type;
    let newState = ClickedNodes;
    let complete = false;
    for (let i = 0; i < newState.length; i++) {
        const item2 = newState[i];
        if (item2 === id) {
            newState.splice(i, 1);
            complete = true;
            break;
        }
        if (type === Nodes[newState[i] - 1].type) {
            newState[i] = id;
            complete = true;
        }
    }
    if (!complete) newState.push(id)
    return newState;
}

export function filterEdgeByPaper(edges: number[], papers: number[], selected: boolean) {
    let years = store.getState().Years
    let Papers: paperInfo[] = store.getState().Papers.Papers

    if (years.length === 0) {
        if (selected)
            return {edges: edges, papers: papers, edgesBG: edgesTotal}
        else
            return {edges: [], papers: papers, edgesBG: edges}
    }

    //get highlight edges
    let edgesHL: number[] = []
    //Filter Papers with condition of Years
    let fpy = papers.filter((v: number) => years.includes(Papers[v - 1].year - 2007))
    for (let i = 0; i < fpy.length; i++) {
        edgesHL = edgesHL.concat(paper2edge[fpy[i]])
    }

    //total Papers of Selected Years
    let psy = getInitialSelectedPapers()

    // total Edges of Selected Years
    let esy: number[] = []
    for (let i = 0; i < psy.length; i++) {
        esy = esy.concat(paper2edge[psy[i]])
    }

    //de-weight
    edgesHL = Array.from(new Set(edgesHL))
    esy = Array.from(new Set(esy))


    //filter edges
    let edgesS = edgesHL.filter((v: number) => edges.includes(v))
    if (selected)
        return {edges: edgesS, papers: fpy, edgesBG: esy}
    else
        return {edges: [], papers: fpy, edgesBG: esy}
}

//get papers of selected years
export function getInitialSelectedPapers() {
    const years = store.getState().Years
    const Papers: paperInfo[] = store.getState().Papers.Papers
    let selected: number[] = [];
    for (let i = 0; i < Papers.length; i++) {
        const item = Papers[i];
        if (item.nodeList.length > 0 && item.id !== 130) {
            selected.push(item.id);
        }
    }
    if (years.length > 0) {
        selected = selected.filter((v) => years.includes(Papers[v - 1].year - 2007))
    }
    return selected;
}

// gets Ids of nodes returns the data of nodes with form of Node[]
export function getNodeListById(ids: number[]) {
    // const s = this.props.state.NodesData.Nodes;
    const s = store.getState().NodesData.Nodes;
    let L: Node[] = [];
    for (let i = 0; i < ids.length; i++) {
        L.push(s[ids[i] - 1]);
    }
    return L;
}


export function filterPapersBySelectedPapers(Papers: paperInfo[], selectedPapers: number[]) {
    let selected: paperInfo[] = [];
    for (let i = 0; i < selectedPapers.length; i++) {
        selected.push(Papers[selectedPapers[i] - 1])
    }
    return selected;
}
